import {Button, Checkbox, message, Modal, Popover, Skeleton, Tooltip,} from 'antd'
import {course_createCourseClass_Api, course_getCourseClassesByOwner_Api,} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {FullSideModalLayout} from 'components/Modal/SideModalLayout'
import copyToClipboard from 'copy-to-clipboard'
import {getRouteSearchParams, useRouteSearchParam,} from 'envs/_current/history'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BsLayoutThreeColumns} from 'react-icons/bs'
import {IoCopyOutline} from 'react-icons/io5'
import {MdOutlineArrowForward} from 'react-icons/md'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {ClassActionTypes} from 'views/AppLocals/Course'
import {CreateCourseClassModal} from 'views/AppLocals/Course/CourseClass/CourseClassForm'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import LoadingBlock from 'views/Loading/LoadingBlock'
import {NullAsDefault} from 'views/Shared'
import EmptyHolder from '../../../../components/EmptyHolder'
import getTitle from '../../../../helpers/getTitle'
import preventParentEvent from '../../../../helpers/preventParentEvent'
import {renderIf} from '../../../Shared'
import CourseClassFilter from '../components/filters/CourseClassFilter'
import {CourseClassPanelDetail} from './CourseClassList/CourseClassPanelDetail'
import PagePaginationWrapper from "../../../../modules/asyncCache/components/PagePagination/PagePaginationWrapper";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

// Mã lớp + Giảng viên đã GOM vào cùng 1 cột "classes" (xem ClassTableRow bên dưới) - trước đây 4 cột
// riêng (mã/lớp/giảng viên/học viên) chiếm quá nhiều bề ngang trong khi mã lớp/giảng viên chỉ là
// thông tin phụ đi kèm tên lớp, không cần đứng cột riêng. "students" vẫn giữ optional/toggle-able
// qua column-picker (BsLayoutThreeColumns) như cũ.
const COLUMN_DEFS = [
    {
        key: 'classes',
        label: 'classes',
        required: true,
        defaultVisible: true,
        width: '85%',
    },
    {
        key: 'students',
        label: 'students',
        required: false,
        defaultVisible: true,
        width: '15%',
    },
]
const DEFAULT_VISIBLE = new Set(
    COLUMN_DEFS.filter((c) => c.defaultVisible).map((c) => c.key)
)
const ColVisContext = React.createContext({
    visibleCols: DEFAULT_VISIBLE,
    onToggleCol: () => {
    },
})

const SHOW_DETAIL = 'SHOW_DETAIL'

// Action đơn giản còn LẠI DUY NHẤT 1 nút "xem chi tiết" (mở popup CourseClassPanelDetail) - trước
// đây có tới 5 nút/cột (mã lớp riêng, xem/điểm danh/bảng điểm/xếp loại/sửa-xóa) nhưng TẤT CẢ đều chỉ
// mở lại đúng popup này, chỉ khác initialTab (điểm danh -> tab "attendance", bảng điểm -> tab
// "grading"...) hoặc trùng chức năng đã có sẵn NGAY TRONG popup (Sửa/Xóa lớp đã có ở tab "Cấu hình
// Lớp học", "final assessment" vẫn còn lối vào khác ở CourseClassStudentTab.js) - bạn yêu cầu bỏ hết,
// chỉ cần mở popup lên, người dùng tự chọn tab bên trong (SideTabNav của CourseClassPanelDetail).
// Mã lớp + Giảng viên gom vào cùng ô "Lớp học" (dòng phụ nhỏ bên dưới tên lớp) thay vì đứng cột riêng.
const ClassTableRow = ({
                           item,
                           index,
                           onRowClick,
                       }) => {
    const t = useTranslate()
    const {visibleCols} = useContext(ColVisContext)
    const {
        coordinators = [],
        number_of_students,
        course_class_idcode,
        dedicated_teacher,
    } = item ?? {}
    const firstCoordinator = coordinators[0]
    // dedicated_teacher - CHỈ fallback khi lớp CHƯA gán coordinator thủ công, BE tự suy khi lớp có
    // ĐÚNG 1 môn học + ĐÚNG 1 giảng viên dạy qua thời khoá biểu (xem
    // CourseClassTransformer::getDedicatedSubjectTeacher).
    const teacherLabel = firstCoordinator?.teacher_name || (dedicated_teacher ? getTitle(dedicated_teacher) : null)

    return (
        <tr
            className={classNames(
                'border-b border-color-50 hover:bg-blue-50 cursor-pointer transition-colors',
                index % 2 !== 0 && 'bg-gray-50'
            )}
            onClick={() => onRowClick(item)}>
            <td className="px-3 py-2">
                <div className="flex flex-col gap-0.5 min-w-0">
                    {/* Mã lớp đứng LIỀN TRƯỚC tên lớp, cùng 1 hàng (bạn yêu cầu) - shrink-0 để mã
                        không bị bóp khi tên lớp dài, tên lớp mới là phần truncate. */}
                    <div className="flex items-center gap-2 min-w-0">
                        {renderIf(
                            course_class_idcode,
                            <span
                                onClick={(e) => {
                                    preventParentEvent(e)
                                    copyToClipboard(course_class_idcode)
                                    message.info(t('copied'))
                                }}
                                className="shrink-0 whitespace-no-wrap text-xs font-mono font-medium text-blue-500 hover:text-blue-600 cursor-pointer">
                                #{course_class_idcode}
                                <IoCopyOutline size={12} className="ml-1"/>
                            </span>
                        )}
                        <span className="block truncate text-sm font-medium text-color-000 hover:text-primary">
                            {getTitle(item)}
                        </span>
                    </div>
                    {renderIf(
                        teacherLabel,
                        <span className="text-xs text-color-300 truncate">{teacherLabel}</span>
                    )}
                </div>
            </td>
            {visibleCols.has('students') && (
                <td className="px-3 py-2 text-center">
          <span className="text-sm font-medium text-color-100">
            {number_of_students ?? 0}
          </span>
                </td>
            )}
            <td className="px-2 py-2 text-right whitespace-no-wrap">
                <Tooltip title={t('view detail')}>
                    <button
                        className="mx-auto p-1 flex flex-center rounded-md hover:bg-indigo-100 text-indigo-400 hover:text-indigo-600 transition-colors"
                        onClick={(e) => {
                            e.stopPropagation()
                            onRowClick(item)
                        }}>
                        <MdOutlineArrowForward size={18}/>
                    </button>
                </Tooltip>
            </td>
        </tr>
    )
}

const TableLoadingRows = () => {
    const {visibleCols} = useContext(ColVisContext)
    const visibleDefs = COLUMN_DEFS.filter(
        (c) => c.required || visibleCols.has(c.key)
    )

    return (
        <>
            {[...Array(4)].map((_, i) => (
                <tr
                    key={i}
                    className="border-b border-color-50">
                    {visibleDefs.map((col) => (
                        <td
                            key={col.key}
                            className="px-3 py-3">
                            <Skeleton.Input
                                block
                                active
                                size="small"
                                style={{height: 20}}
                            />
                        </td>
                    ))}
                    <td className="px-1 py-3 text-center">
                        <Skeleton.Input
                            active
                            size="small"
                            style={{width: 20, minWidth: 20, height: 20}}
                        />
                    </td>
                </tr>
            ))}
        </>
    )
}

const ClassTableWrapper = ({children}) => {
    const t = useTranslate()
    const {visibleCols, onToggleCol} = useContext(ColVisContext)
    const optionalCols = COLUMN_DEFS.filter((c) => !c.required)
    const visibleDefs = COLUMN_DEFS.filter(
        (c) => c.required || visibleCols.has(c.key)
    )

    const colPickerContent = (
        <div className="flex flex-col gap-2 py-1">
            {optionalCols.map((col) => (
                <Checkbox
                    key={col.key}
                    checked={visibleCols.has(col.key)}
                    onChange={() => onToggleCol(col.key)}>
                    <span className="text-sm">{t(col.label)}</span>
                </Checkbox>
            ))}
        </div>
    )

    return (
        <div className="overflow-x-auto">
            <table className="w-full table-fixed">
                <colgroup>
                    {visibleDefs.map((col) => (
                        <col
                            key={col.key}
                            style={col.width ? {width: col.width} : {}}
                        />
                    ))}
                    <col style={{width: 40}}/>
                </colgroup>
                <thead>
                <tr className="background-100 border-b border-color-100 11-11">
                    {visibleDefs.map((col) => (
                        <th
                            key={col.key}
                            className="px-3 py-2 text-left text-xs font-semibold text-color-300 uppercase tracking-wider whitespace-no-wrap">
                            {t(col.label)}
                        </th>
                    ))}
                    <th className="px-2 py-2">
                        <Popover
                            content={colPickerContent}
                            trigger="click"
                            placement="bottomRight">
                            <button
                                className="mx-auto p-1 flex flex-center rounded-md hover:background-200 text-color-300 hover:text-color-100 transition-colors">
                                <BsLayoutThreeColumns size={14}/>
                            </button>
                        </Popover>
                    </th>
                </tr>
                </thead>
                <tbody className="background divide-y divide-color-50">
                {children}
                </tbody>
            </table>
        </div>
    )
}

const HEADER_TEXT_BY_REL = {
    'course-class': {
        title: 'classes',
        description: 'note course class description',
    },
    'course-class-timetable': {
        title: 'class timetable title',
        description: 'class timetable list description',
    },
}

const ClassListManager = ({
                              owner_id,
                              owner_type,
                              defaultTab = 'schedule',
                              filter_actions = {
                                  sortBy: 'sort-by',
                                  keyword: 'keyword',
                                  course_id: 'course-id',
                              },
                              ...props
                          }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const location = useLocation()
    const history = useHistory()
    const rel = useRouteSearchParam('rel')
    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const course_id = useRouteSearchParam(filter_actions.course_id)
    const class_id_param = useRouteSearchParam('class-id')
    const class_tab_param = useRouteSearchParam('class-tab')

    const headerText =
        HEADER_TEXT_BY_REL[rel] || HEADER_TEXT_BY_REL['course-class']

    // class_id/tab trên URL cho phép reload/chia sẻ link giữ đúng panel + tab đang mở
    const syncDetailQuery = useCallback(
        (classId, tab) => {
            const searchParams = getRouteSearchParams()
            classId
                ? searchParams.set('class-id', classId)
                : searchParams.delete('class-id')
            tab
                ? searchParams.set('class-tab', tab)
                : searchParams.delete('class-tab')
            history.replace({search: '?' + searchParams.toString()})
        },
        [history]
    )

    const [action, setAction] = useState(() =>
        class_id_param
            ? {
                type: SHOW_DETAIL,
                value: {id: class_id_param},
                tab: class_tab_param || defaultTab,
            }
            : {type: undefined, value: undefined}
    )
    const [refreshKey, setRefreshKey] = useState()
    const [visibleCols, setVisibleCols] = useState(DEFAULT_VISIBLE)

    const onToggleCol = useCallback(
        (key) => {
            setVisibleCols((prev) => {
                const next = new Set(prev)
                next.has(key) ? next.delete(key) : next.add(key)
                return next
            })
        },
        [visibleCols]
    )

    const onError = notifyOnError(t)

    const reload = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onCreate} = useAsyncAction({
        apiInfo: course_createCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            reload()
        },
    })

    const handleAction = (type, params, tab) => {
        switch (type) {
            case SHOW_DETAIL:
                setAction({type, value: params, tab: tab || defaultTab})
                syncDetailQuery(getId(params), tab || defaultTab)
                break
            case ClassActionTypes.CLASS_CREATE:
                setAction({type, value: params})
                break
            default:
                break
        }
    }

    const onCancel = () => {
        setAction({})
        if (action?.type === SHOW_DETAIL) syncDetailQuery(undefined, undefined)
    }

    // "Sửa"/"Xóa" lớp (trước đây mở qua icon gear riêng ở mỗi dòng) và "final assessment" (trước đây
    // icon TbTableOptions riêng) đã BỎ khỏi bảng - cả 2 chỉ mở lại đúng popup CourseClassPanelDetail
    // (Sửa/Xóa nằm sẵn ở tab "Cấu hình Lớp học" của popup đó; "final assessment" vẫn còn lối vào khác
    // ở CourseClassStudentTab.js, không mất chức năng, chỉ bỏ lối tắt trùng) - xem comment ClassTableRow.
    const modal = useMemo(() => {
        if (action?.type === SHOW_DETAIL) {
            const classId = getId(action.value)
            return (
                <FullSideModalLayout
                    right={true}
                    title={
                        <div className="font-bold text-color-000 tracking-wide">
                            {t('class detail')}
                        </div>
                    }
                    onCancel={onCancel}>
                    <div className="p-3">
                        <CourseClassPanelDetail
                            class_id={classId}
                            owner_id={owner_id}
                            owner_type={owner_type}
                            initialTab={action.tab || 'schedule'}
                            onCancel={onCancel}
                            onTabChange={(tab) => syncDetailQuery(classId, tab)}
                            // Sửa lớp ở tab "Cấu hình Lớp học" trong popup KHÔNG đóng popup (khác xóa) -
                            // chỉ cần refresh lại bảng danh sách phía sau (cột Giảng viên/Học viên...).
                            onChanged={() => setRefreshKey(Date.now())}
                        />
                    </div>
                </FullSideModalLayout>
            )
        }

        let title
        let Content = NullAsDefault
        let modal_params = {}
        let params = {}
        let Wrapper = ({children}) => children({item: {}})

        switch (action?.type) {
            case ClassActionTypes.CLASS_CREATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('create course class')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        const {course_id: cid, ...rest} = values ?? {}
                        onCreate({...rest}, {id: cid})
                    },
                }
                modal_params = {width: 720}
                Content = CreateCourseClassModal
                break
            default:
                return null
        }

        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                open={!!action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (isLoading) return <LoadingBlock/>
                        return (
                            <Content
                                {...params}
                                {...{item, owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action, owner_id, owner_type])

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const renderList = useCallback(
        ({filter_actions, keyword, sortBy: currentSort, filterBy, refreshKey}) => (
            <PagePaginationWrapper
                apiInfo={course_getCourseClassesByOwner_Api}
                query={bindQueryParams([{id: owner_id}, {type: owner_type}])}
                values={{filter_actions, keyword, sort_by: currentSort, ...(filterBy ?? {})}}
                refreshKey={refreshKey}
                renderItem={(item, index) => (
                    <ClassTableRow
                        key={index}
                        item={item}
                        index={index}
                        onRowClick={(i) => handleAction(SHOW_DETAIL, i)}
                    />
                )}
                renderLoading={() => (
                    <ClassTableWrapper>
                        <TableLoadingRows/>
                    </ClassTableWrapper>
                )}
                renderEmpty={() => (
                    <ClassTableWrapper>
                        <tr>
                            <td
                                className="border p-2"
                                // "classes" (required) + "students" (nếu đang bật) + 1 cột action duy nhất
                                colSpan={visibleCols.size + 2}>
                                <EmptyHolder/>
                            </td>
                        </tr>
                    </ClassTableWrapper>
                )}
                Wrapper={({children}) => (
                    <ClassTableWrapper>{children}</ClassTableWrapper>
                )}
            />
        ),
        [owner_id, owner_type, t, handleAction, visibleCols, isLg, filter_actions]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {owner_id, owner_type},
        onInit: ({
                     onSortChange = NullAsDefault,
                     onFilterChange = NullAsDefault,
                 }) => {
            onFilterChange({course_id})
            onSortChange(sortBy)
        },
        renderList,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: false,
        query_params: filter_actions,
        AdvancedFilter: CourseClassFilter,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })

    return (
        <ColVisContext.Provider value={{visibleCols, onToggleCol}}>
            <div className="flex flex-1 flex-col space-y-3">
                <div className="flex flex-col md:flex-row md:items-center gap-3">
                    <div className="flex flex-col flex-1">
                        <h2 className="font-bold text-xl text-gray-800 tracking-wide class-list-workspace">
                            {t(headerText.title)}
                        </h2>
                        <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                        <div className="mt-1 mr-4 text-sm text-color-300 tracking-wider 3333">
                            {t(headerText.description)}
                        </div>
                    </div>
                    <Button
                        color="primary"
                        variant="solid"
                        className="px-6 py-2 font-semibold rounded-lg"
                        onClick={() => handleAction(ClassActionTypes.CLASS_CREATE)}>
                        {t('create')}
                    </Button>
                </div>
                {pager_widget}
                {modal}
                <div className="h-16"/>
            </div>
        </ColVisContext.Provider>
    )
}

const CourseClassList = compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(ClassListManager)

export default CourseClassList
